const { CountUp } = require('countup.js');

const elements = Array.from(document.querySelectorAll('.countup'));

const countupOptions = {
    startVal: 0,
    duration: 3,
    separator: ',',
    decimal: '.',
    autoAnimate: true,
    autoAnimateOnce: true,
};

elements.forEach(element => {
    const number = Number(element.textContent);
    const countUp = new CountUp(element, number, countupOptions);
});
